import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import image from "../../../img/many people.jpg";

class HLStep7Form extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                        ...Theme.pageHeadingWithBannerStyle,
                    }}
                >
                    {HLConst.step7AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step7AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>Start implementing and monitor if coverage of your prioritized interventions increases.</p>

                <ul>
                    <li>Eventually, you may adjust interventions as their priorities may change</li>
                </ul>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;As part of your mid-year review you review coverage of the interventions you decided to
                        prioritize. Your meetings with pharmacy staff to address supply chain issues related to oral
                        antibiotics for pneumonia seem to be working, as coverage of this intervention has increased
                        from 82% to 96% in six months. You decide to stop the meetings mid-year and put even more effort
                        on activities designed to increase the coverage of other interventions.
                    </p>
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        // const downloadGuideBtn =
        //     <HLDownloadGuideBtn/>;

        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step6Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.FAQsHelpForm)}
            />
        );

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                <img
                    style={{
                        width: "calc(100% - 1px)",
                    }}
                    src={image}
                    alt=""
                />

                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLStep7Form;
